var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.firstShorthand
    ? _c("div", { staticClass: "price-validation-badge-wrapper" }, [
        _c("span", { class: ["price-validation-badge", _vm.badgeClass] }, [
          _vm._v("\n    " + _vm._s(_vm.firstShorthand) + "\n  "),
        ]),
        _vm._v(" "),
        _vm.additionalCount > 0
          ? _c("span", { class: ["price-validation-badge", _vm.badgeClass] }, [
              _vm._v("\n    +" + _vm._s(_vm.additionalCount) + "\n  "),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }